/**
 * Access allowlist for route/menu permission control.
 * Each key corresponds to a menu route, and the value is the list of allowed user logins.
 */
export const ACCESS_ALLOWLIST: Record<string, string[]> = {
  monitorAlert: [
    'psyajing',
    'demiwang',
    'sujiache',
    'mkzhao',
    'qinxl',
    'yuhayanv',
    'tongxihu',
    'wwutong',
    'xiangmax',
    'zanhxiao',
    'bot-verdict-test',
    'prod-sw',
    'qa-verdictor',
    'hkaichua',
    'hexrui'
  ],
};

/**
 * Normalize a login string by stripping the @domain portion if present.
 * e.g. "bot-verdict-test@lassostg.labcollab.net" -> "bot-verdict-test"
 */
export const normalizeLogin = (login: string): string => {
  const normalized = login.toLowerCase();
  const atIndex = normalized.indexOf('@');
  return atIndex !== -1 ? normalized.substring(0, atIndex) : normalized;
};

/**
 * Check if a user login has access to a specific menu/route.
 * @param menu - The menu/route key (e.g. 'ConfigurationSetting' or 'Configuration Setting')
 * @param login - The user's login alias (may include @domain suffix for bot accounts)
 * @returns true if the user is in the allowlist for the given menu
 */
export const hasMenuAccess = (menu: string, login: string): boolean => {
  const allowlist = ACCESS_ALLOWLIST[menu];
  if (!allowlist) return true; // If no allowlist is defined for the menu, allow access by default
  return allowlist.includes(normalizeLogin(login));
};
